module.exports = __webpack_public_path__ + "static/hyperv_47.d62227f7.png";